/* eslint-disable */
import Vue from 'vue';

export const http = {
 exec: (method, url, params) => {
    const options = {
      method,
      url,
      credentials: true
    }
    if(options.method == "get"){
      options.params = params;
    }else{
      options.body = params;
    }
    // var loginData = '';
    // if (localStorage.getItem('loginData')) {
    //   try{
    //     loginData =  JSON.parse(localStorage.getItem('loginData')).shop;
    //     // console.log('loginData.id: ', loginData.id);
    //     options.xsrfHeaderName = "x-shop";
    //     options.headers = {
    //       'x-shop': loginData.id
    //     }
    //     // options.headers['x-shop'] = loginData.shop.id;
    //   } catch (e) {
    //   }
		// }
    return Vue.http(options);
  },

  get: (url, query) => {
    return query ? http.exec('get', url, query) : http.exec('get', url);
  },

  post: (url, data) => {
    return http.exec('post', url, data);
  },

  put: (url, data) => {
    return http.exec('put', url, data);
  },

  patch: (url, data) => {
    return http.exec('patch', url, data);
  },

  delete: (url, data) => {
    return http.exec('delete', url, data);
  },
  upload: (url, formData) => {
    const options = {
      method:'post',
      body: formData,
      credentials: true,
      url: url
    };
    return Vue.http(options);
  }
}



// WEBPACK FOOTER //
// ./src/utils/http.js